import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
var _context, _context2;
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue';
import template from './index.vdt';
import { colors, sizes } from './styles';
import { useConfigContext } from '../config';
var typeDefs = {
  size: _concatInstanceProperty(_context = []).call(_context, sizes, ['default', String, Number]),
  color: String,
  rotate: Boolean,
  hoverable: Boolean,
  disabled: Boolean
};
var defaults = function defaults() {
  return {
    size: 'default'
  };
};
var defaultColors = _concatInstanceProperty(_context2 = []).call(_context2, colors, ['default']);
export var Icon = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Icon, _Component);
  function Icon() {
    var _context3;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context3 = [this]).call(_context3, args)) || this;
    _this.colors = defaultColors;
    _this.config = useConfigContext();
    return _this;
  }
  return Icon;
}(Component);
Icon.displayName = 'Icon';
Icon.template = template;
Icon.typeDefs = typeDefs;
Icon.defaults = defaults;